import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";

import { TranslateModule } from "@ngx-translate/core";
import { ContentloaderModule } from '@signature-it/ngx-generic/components/contentloader';
import { CartCouponModuleGeneric } from '@signature-it/ngx-catalogue/components/cart/coupon';
import { CartSummaryComponentGeneric } from "./summary";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        ContentloaderModule,
        CartCouponModuleGeneric
    ],
    exports: [CartSummaryComponentGeneric],
    declarations: [CartSummaryComponentGeneric]
})
export class CartSummaryModuleGeneric {}
